import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LeftsidebarComponent } from '../../shared/leftsidebar/leftsidebar.component';
import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component';

// Declares the app shell (header / left-nav / footer) so feature modules
// outside app.module.ts (e.g. WikiModule) can drop in <app-header> /
// <app-leftsidebar> / <app-footer> without re-declaring them (a component
// can only be declared in one NgModule).
@NgModule({
  declarations: [
    HeaderComponent,
    LeftsidebarComponent,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
  ],
  exports: [
    HeaderComponent,
    LeftsidebarComponent,
    FooterComponent,
  ],
})
export class SharedModule { }
